import React from 'react'
import { Form } from "react-bootstrap";

const NivelesAcceso = ({title, onChange, value, userLevel, className, ...props}) => {
  return (
    <Form.Control as="select" title={title} onChange={onChange} value={value} className={className}>
        {//102022<option value="2">Hermana</option>
        }
        <option value="2m">(2) Hermana</option>
        <option value="2l">(2) Laica/o</option>
        <option value="3m">(3) Hermana Edición Perfil</option>
        <option value="3l">(3) Laica/o Edición Perfil</option>
        <option value="8">(8) Secretaría Prov. Auxiliar</option>
        <option value="9">(9) Secretaría Provincial</option>
        <option value="10">(10) Administración General</option>
        {userLevel === 11 && <option value="11">Administración GLOBAL</option>}
    </Form.Control>
  )
}

export default NivelesAcceso